/**
 * Maps dashboard routes to KAI screen context so the sidekick knows where the
 * merchant is - catalog writes work from any screen without navigation.
 */
export function resolveScreenContext(pathname = "") {
  const route = pathname || "/";
  const base = { route, screen: "general" };

  if (route.startsWith("/templates/templatedata")) {
    return { ...base, screen: "template_customizer" };
  }

  // Product list - must be checked before `/catalogue/product*` (prefix collision).
  if (route === "/catalogue/products") {
    return { ...base, screen: "products" };
  }
  if (
    route.startsWith("/catalogue/products/add") ||
    route.startsWith("/catalogue/products/edit/")
  ) {
    return { ...base, screen: "product_edit" };
  }
  if (route.startsWith("/catalogue/product/")) {
    return { ...base, screen: "product_edit" };
  }

  if (route.startsWith("/catalogue/brands")) {
    return { ...base, screen: "brands" };
  }
  if (route.startsWith("/catalogue/categories")) {
    return { ...base, screen: "categories" };
  }
  if (route.startsWith("/catalogue/attributes")) {
    return { ...base, screen: "attributes" };
  }
  if (route === "/dashboard" || route === "/") {
    return { ...base, screen: "dashboard" };
  }
  if (route.startsWith("/templates")) {
    return { ...base, screen: "templates" };
  }
  if (route.startsWith("/settings")) {
    return { ...base, screen: "settings" };
  }
  if (route.startsWith("/orders")) {
    return { ...base, screen: "orders" };
  }
  if (route.startsWith("/customers")) {
    return { ...base, screen: "customers" };
  }
  return base;
}
